import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { useCallback } from 'react';
import { Modal, ModalActions, ModalContent } from '../Modal';
import { Button } from '../Button';

const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }
}));

export type CheckYourInboxDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const CheckYourInboxDialog: React.VFC<CheckYourInboxDialogProps> = ({ open, onClose }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  const handleRequestNewLink = useCallback(() => {
    onClose();
  }, [ onClose ]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      title={l10n.dashboard.actionItems.verifyEmail.modalTitle}
    >
      <ModalContent className={classes.content}>
        <Box className={classes.details}>
          <Typography>
            {l10n.dashboard.actionItems.verifyEmail.modalText1}
          </Typography>
          <Typography>
            {l10n.dashboard.actionItems.verifyEmail.modalText2}
          </Typography>
        </Box>
      </ModalContent>
      <ModalActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleRequestNewLink}
          style={{ width: '88px' }}
        >
          {l10n.general.ok}
        </Button>
      </ModalActions>
    </Modal>
  );
};
